export const safetyContacts = (state = { open: false, data: "" }, action) => {
  switch (action.type) {
    case "USER::EDIT_SAFETY_CONTACT":
      return action.payload;
    default:
      return state;
  }
};

export default safetyContacts;
